import { createContext, useState, type FC, type ReactNode, useContext, useRef } from 'react';
import { trackEvent } from 'dibs-tracking';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';

type StoryTellingTrackingContextType = {
    fireStorytellingVisibilityTracking: ({ isVisible }: { isVisible: boolean }) => void;
};

const PdpSharedStorytellingTrackingContext = createContext<StoryTellingTrackingContextType>({
    fireStorytellingVisibilityTracking: () => {},
});

type Props = {
    children: ReactNode;
};

export const PdpSharedStorytellingTrackingContextProvider: FC<Props> = ({ children }) => {
    const [hasFiredTracking, setHasFiredTracking] = useState(false);
    return (
        <PdpSharedStorytellingTrackingContext
            value={{
                fireStorytellingVisibilityTracking: ({ isVisible }: { isVisible: boolean }) => {
                    if (isVisible && !hasFiredTracking) {
                        trackEvent({
                            category: 'product',
                            action: 'storytelling module reached',
                            label: 'pdp',
                        });
                        setHasFiredTracking(true);
                    }
                    return;
                },
            }}
        >
            {children}
        </PdpSharedStorytellingTrackingContext>
    );
};

export const PdpSharedStorytellingTrackingWrapper: FC<Props> = ({ children }) => {
    const storyTellingRef = useRef(null);
    const { fireStorytellingVisibilityTracking } = useContext(PdpSharedStorytellingTrackingContext);
    return (
        <>
            <VisibilityTracker
                elementRef={storyTellingRef}
                onVisibilityChange={fireStorytellingVisibilityTracking}
            />
            <div ref={storyTellingRef}>{children}</div>
        </>
    );
};
